<!--产品价值-->

<template>
     <div>
        <div class='child-body'>
            <div class='scenarioTitle'>{{name}}</div>
            <ul class='LegalAI-content'>
                <li v-for="item of data">
                    <div class="imgBox">
                        <img :src="item.img" alt="">
                    </div>
                    <div>
                        <span class="LegalAI-title">{{item.name}}</span>
                        <div class="LegalAI-html">
                            {{item.html}}
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'index',
    props: ['data','name']
}
</script>
<style scoped>
.LegalAI-content{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
}
.LegalAI-content li{
    display: flex;
    width: 46.7%;
}
.LegalAI-title{
    display: inline-block;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #303133;
    line-height: 30px;
    margin-bottom: 15px;
}
.LegalAI-html{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #606266;
    line-height: 30px;
    margin-bottom: 70px;
}
.imgBox img{
    width: 28px;
    margin: 5px 20px;
}
</style>